import { Flex, useBreakpointValue } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '@/components/LoginForm';
import LoginHero from '@/components/LoginHero';
import ensureAuthenticated from '@/contexts/ensureAuthenticated';

export default function Login() {
    const { authenticated } = ensureAuthenticated();

    const navigate = useNavigate();

    const showHero = useBreakpointValue({ base: false, md: true });
    
    useEffect(() => {
        if (authenticated) navigate('/');
    }, [authenticated]);

    return (
        <Flex
            minW='100vw'
            minH='100vh'
            maxW='100vw'
            maxH='100vh'
            bgColor='#2D3748'
        >
            <Flex w='100%' minH='100%' position='relative'>
            {showHero && <LoginHero />}

                <LoginForm />
            </Flex>
        </Flex>
    );
}
